import React, { Fragment } from "react";
import { Col } from "antd";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import ProfileBio from "./ProfileBio";
import EventBar from "./Eventbar";

import ProfileBioAccordian from "./Accordians/ProfileBioAccordian";

import { useCurrentPage } from "../hooks/useCurrentPage";
import { PROFILE } from "../../Store/Features/ProfileSlice";

function SideBar({ current, md, big, data }) {
  var currentProfile = useSelector(PROFILE);
  const ID = useSelector(PROFILE);

  const {
    isAllOrganizer: isOrganizer,
    isAllPlayer: isPlayer,
    isAllTeam: isTeam,
    isAllPanel: isPanel
  } = useCurrentPage();
  const { pathname } = useLocation();

  let currentPageFor = isOrganizer || isPanel;
  const sportType = isPlayer || isTeam;

  return (
    <Fragment>
      <Col xs={24} sm={24} md={24} lg={big ? 24 : md ? 9 : 9} xl={big ? 24 : 9}>
        {/* Bio */}
        <Fragment>
          <div className="d-md-block d-none pl-2 pr-2">
            <ProfileBioAccordian
              Rating={currentProfile?.rating || 0}
              id={currentProfile?._id}
              type={currentPageFor}
              profile={currentProfile}
              data={data}
              current={current}
              isOrganizer={isOrganizer}
              sportType={
                sportType
                  ? currentProfile?.typeofsports ||
                    currentProfile?.sportType ||
                    currentProfile?.sportsyouplay
                  : false
              }
            />
          </div>
          <div className="d-md-none">
            <ProfileBio
              Rating={currentProfile?.rating || 0}
              id={currentProfile?._id}
              profile={currentProfile}
              type={currentPageFor}
              data={data}
              current={current}
              isOrganizer={isOrganizer}
              sportType={
                sportType
                  ? currentProfile?.typeofsports ||
                    currentProfile?.sportType ||
                    currentProfile?.sportsyouplay
                  : false
              }
            />
          </div>
        </Fragment>

        {/* Event Historty */}
        {pathname.includes(current) ? (
          <EventBar
            big
            eventHistoryLInk={`/view/${current}/${ID?._id}/eventhistory`}
            current={current}
          />
        ) : (
          <EventBar big />
        )}
      </Col>
    </Fragment>
  );
}

export default SideBar;
